import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select, { Async } from 'react-select';
import { createApiClient } from '../services/ApiClient';
import Loader from 'react-loader-advanced';

import {
  createForm,
  errorCreateForm,
  onUploadProtocol,
  onChangeProtocol,
} from '../actions';

const modalFormDefaultState = {
  FullNameOrganization: {
    label: 'Название компании',
    value: '',
  },
  INNOfOrganization: {
    label: 'ИНН',
    value: '',
  },
  OGRNOfOrganization: {
    label: 'ОГРН',
    value: '',
  },
};

import LoadingDots from './ui/LoadingDots';
import ReactModalWithStyle from './ui/Modal/ReactModalWithStyle';
import {
  Alert,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import { object, mixed } from 'yup';

const yupValidation = object().shape({
  protocol: mixed()
    .required('Файл не может быть пустым')
    .test('fileSize', 'Слишком большой размер файла', (value) => {
      return value.size <= 2000000;
    })
    .test(
      'fileExtension',
      'Файл должен быть формата .pdf, .doc, .docx',
      (value) => {
        return (
          value.name.split('.').pop() === 'pdf' ||
          value.name.split('.').pop() === 'doc' ||
          value.name.split('.').pop() === 'docx'
        );
      },
    ),
});

class RequestCreate extends Component {
  state = {
    typeRequest: '',
    enFieldsAvailable: '0',
    modal: false,
    protocol: null,
    mtkModal: false,
    companyRequest: '',
    modalForm: modalFormDefaultState,
    selectedProject: '',
    selectedProjectInfo: {},
    companyProjectsList: [],
    isProjectDataLoading: false,
    hasMtkStatus: null,
    isAlertShown: false,
    alertText: '',
    alertType: '',
  };

  componentDidUpdate(_prevProps, prevState) {
    if (this.state.protocol !== prevState.protocol) this.handleProtocolUpdate();
  }

  handleProtocolUpdate() {
    const { onChangeProtocol } = this.props;
    onChangeProtocol();
  }

  getOptions = (input, callback) => {
    const api = createApiClient();

    if (input) {
      api.getCompanySuggestions(input, {
        success: (suggestions) => {
          const options = suggestions.map((item) => ({
            label: `${item.value} | ИНН ${item.data.inn}`,
            value: `${item.value} | ИНН ${item.data.inn}`,
            modalForm: {
              FullNameOrganization: {
                label: modalFormDefaultState.FullNameOrganization.label,
                value:
                  item?.data?.name?.short_with_opf ??
                  modalFormDefaultState.FullNameOrganization.value,
              },
              INNOfOrganization: {
                label: modalFormDefaultState.INNOfOrganization.label,
                value:
                  item?.data?.inn ??
                  modalFormDefaultState.INNOfOrganization.value,
              },
              OGRNOfOrganization: {
                label: modalFormDefaultState.OGRNOfOrganization.label,
                value:
                  item?.data?.ogrn ??
                  modalFormDefaultState.OGRNOfOrganization.value,
              },
            },
          }));

          callback(null, {
            options,
          });
        },
        error: () => {
          alert('Ошибка сервера');
        },
      });
    } else {
      callback(null, {
        options: [],
      });
    }
  };

  onCreate = () => {
    const { createForm, onUploadProtocol, errorCreateFormAction } = this.props;
    const { typeRequest, protocol, enFieldsAvailable } = this.state;

    if (typeRequest === '1') {
      try {
        onUploadProtocol({
          enFieldsAvailable,
          ...yupValidation.validateSync({
            protocol,
          }),
        });
      } catch (e) {
        errorCreateFormAction(e.message);
      }
    } else {
      createForm({
        typeRequest: this.state.typeRequest,
        enFieldsAvailable: this.state.enFieldsAvailable,
      });
    }
  };

  toggleModal = () => {
    this.setState((state) => ({
      modal: !state.modal,
      protocol: null,
    }));
  };

  toggleMtkModal = () => {
    this.setState((state) => ({
      mtkModal: !state.mtkModal,
    }));
  };

  getResidentProjectsInfo(value) {
    const api = createApiClient();
    this.setState({
      isProjectDataLoading: true,
    });
    api.getResidentProjectsInfo(value, {
      success: (data) => {
        this.setState((prevState) => ({
          ...prevState,
          isProjectDataLoading: false,
          companyProjectsList: data.Projects.map((item) => ({
            label: item.Name,
            value: item.Name,
            description: item.Description,
          })),
        }));
      },
      error: () => {
        alert('Ошибка при попытке загрузки проектов');
        this.setState({
          isProjectDataLoading: false,
        });
      },
    });
  }

  filterOrganizations = (options, searchQuery) => {
    return options.filter((option) => {
      const isNameEntry = option.value
        .toUpperCase()
        .includes(searchQuery.toUpperCase());
      const isOgrnEntry =
        option.modalForm?.OGRNOfOrganization?.value?.includes(searchQuery);
      const isInnEntry =
        option.modalForm?.INNOfOrganization?.value?.includes(searchQuery);

      return isNameEntry || isOgrnEntry || isInnEntry;
    });
  };

  checkSkolkovoRelations(value) {
    const api = createApiClient();
    this.setState({
      isProjectDataLoading: true,
    });
    api.checkIsCompanyRelatesToSkolkovo(value, {
      success: (data) => {
        this.setState({
          hasMtkStatus: data.HasMtkStatus,
        });
        this.setState({
          isProjectDataLoading: false,
        });
        if (data.HasMtkStatus) {
          this.getResidentProjectsInfo(value);
        }
      },
      error: () => {
        alert('Ошибка при попытке связаться с Реестром МТК');
        this.setState({
          isProjectDataLoading: false,
        });
      },
    });
  }

  onMtkModalClose() {
    this.setState({
      companyRequest: '',
      modalForm: modalFormDefaultState,
      selectedProject: '',
      selectedProjectInfo: {},
      companyProjectsList: [],
      hasMtkStatus: null,
    });
    this.toggleMtkModal();
  }

  onFormSubmit() {
    const formData = {};
    for (const [key, value] of Object.entries(this.state.modalForm)) {
      formData[key] = value.value;
    }
    const payload = {
      ...formData,
      projectName: this.state.selectedProjectInfo.value,
      projectDescription: this.state.selectedProjectInfo.description,
    };
    const api = createApiClient();
    api.sendMtkRequest(payload, {
      success: (data) => {
        this.setState({
          isAlertShown: true,
          alertText:
            'Заявка на статус МТК успешно создана! Переход к заявке...',
          alertType: 'success',
        });
        setTimeout(() => {
          if (data.link) {
            window.location.href = data.link;
          }
        }, 1000);
      },
      error: () => {
        this.setState({
          isAlertShown: true,
          alertText: 'Ошибка при создании заявки на статус МТК',
          alertType: 'danger',
        });
      },
    });
  }

  handleDismiss() {
    this.setState({
      isAlertShown: false,
      alertText: '',
      alertType: '',
    });
  }

  render() {
    const { loaders } = this.props;

    return (
      <LoadingDots show={loaders?.['companies'] || !this.props.modeLoaded}>
        <div className="text-block">
          <div className="from-group">
            <div className="input-group row">
              <div className="col-sm-2 col-xs-12 ">
                <label>Тип заявки</label>
                <Select
                  autosize={false}
                  className={'Select'}
                  name="form-field-lang"
                  placeholder="Выберите из списка"
                  value={this.state.typeRequest}
                  style={{ borderColor: '#ccc' }} // : "#4eb43e"
                  onChange={(value) =>
                    this.setState((prevState) => ({
                      ...prevState,
                      typeRequest: value?.value || null,
                    }))
                  }
                  options={[
                    {
                      label: 'Заявка на экспертизу',
                      value: '0',
                    },
                    // {
                    //   label: 'Заявка на статус',
                    //   value: '1',
                    // },
                    {
                      label: 'Заявка на статус для МТК',
                      value: '2',
                    },
                  ]}
                />
              </div>

              {/* <div className="col-sm-2 col-xs-12 ">
                <label>Язык заполнения заявки</label>
                <Select
                  autosize={false}
                  className={'Select'}
                  name="form-field-lang"
                  placeholder="Выберите из списка"
                  value={this.state.enFieldsAvailable}
                  style={{ borderColor: '#ccc' }} // : "#4eb43e"
                  onChange={(value) =>
                    this.setState((prevState) => ({
                      ...prevState,
                      enFieldsAvailable: value?.value || null,
                    }))
                  }
                  options={[
                    {
                      label: 'Русский',
                      value: '0',
                    },
                    {
                      label: 'Русский и английский',
                      value: '1',
                    },
                  ]}
                />
              </div> */}

              <div className="col-sm-2 col-xs-12 align-items-end d-flex">
                <button
                  type="button"
                  className="btn btn-success btn-sm w-btn"
                  onClick={
                    this.state.typeRequest === '1'
                      ? this.toggleModal
                      : this.state.typeRequest === '2'
                      ? this.toggleMtkModal
                      : this.onCreate
                  }
                  disabled={!this.state.typeRequest}
                >
                  Создать заявку
                </button>
              </div>
            </div>
          </div>
        </div>
        <ReactModalWithStyle
          isOpen={this.state.mtkModal}
          onRequestClose={this.onMtkModalClose.bind(this)}
          appElement={document.body}
          modalHeader={
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <b>Компания</b>
              <button
                type={'button'}
                onClick={this.onMtkModalClose.bind(this)}
                style={{
                  background: 'none',
                  border: 'none',
                }}
              >
                <svg
                  width="16px"
                  height="16px"
                  viewBox="0 0 16 16"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="16" height="16" id="icon-bound" fill="none" />
                  <polygon
                    points="14.707,2.707 13.293,1.293 8,6.586 2.707,1.293 1.293,2.707 6.586,8 1.293,13.293 2.707,14.707 8,9.414
	13.293,14.707 14.707,13.293 9.414,8 "
                  />
                </svg>
              </button>
            </div>
          }
          modalFooter={
            <div>
              <button
                type="button"
                className="btn btn-default btn-secondary"
                onClick={this.onMtkModalClose.bind(this)}
              >
                Отмена
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={!this.state.selectedProject}
                onClick={this.onFormSubmit.bind(this)}
              >
                Сохранить
              </button>
            </div>
          }
        >
          <div>
            {!this.state.isAlertShown && (
              <Async
                cache={false}
                autosize={true}
                autoload={true}
                className={'Select'}
                name="form-field-lang"
                placeholder="Поиск компаний"
                value={this.state.companyRequest}
                style={{ borderColor: '#ccc' }} // : "#4eb43e"
                loadOptions={this.getOptions}
                filterOptions={this.filterOrganizations}
                onChange={(value) => {
                  this.setState((prevState) => ({
                    ...prevState,
                    companyRequest: value?.value || null,
                    modalForm: value?.modalForm || null,
                  }));
                  this.checkSkolkovoRelations(
                    value.modalForm.OGRNOfOrganization.value,
                  );
                }}
              />
            )}

            {this.state.isAlertShown && (
              <Alert
                bsStyle={this.state.alertType}
                onDismiss={this.handleDismiss}
              >
                <p>{this.state.alertText}</p>
              </Alert>
            )}

            <Loader show={this.state.isProjectDataLoading} message={'Загрузка'}>
              {!this.state.isAlertShown && (
                <form style={{ marginTop: '25px' }}>
                  {Object.keys(this.state.modalForm).map((key) => {
                    return (
                      <FormGroup controlId={key} key={key}>
                        <ControlLabel>
                          {this.state.modalForm[key].label}
                        </ControlLabel>
                        <FormControl
                          value={this.state.modalForm[key].value}
                          disabled={true}
                        />
                      </FormGroup>
                    );
                  })}
                  {this.state.companyRequest &&
                    typeof this.state.hasMtkStatus === 'boolean' && (
                      <div
                        style={{
                          color: this.state.hasMtkStatus ? 'green' : 'red',
                        }}
                      >
                        Компания {!this.state.hasMtkStatus && 'не'} найдена в
                        Реестре МТК
                      </div>
                    )}
                  {this.state.companyRequest && (
                    <FormGroup controlId="Проект" key="Проект">
                      <ControlLabel>Проект</ControlLabel>
                      <Select
                        autosize={false}
                        className={'Select'}
                        name="form-field-lang"
                        disabled={!this.state.companyProjectsList.length}
                        placeholder="Выберите из списка"
                        value={this.state.selectedProject}
                        style={{ borderColor: '#ccc' }} // : "#4eb43e"
                        isLoading={this.state.isProjectDataLoading}
                        onChange={(value) =>
                          this.setState((prevState) => ({
                            ...prevState,
                            selectedProjectInfo: value,
                            selectedProject: value?.value || null,
                          }))
                        }
                        options={this.state.companyProjectsList}
                      />
                    </FormGroup>
                  )}
                </form>
              )}
            </Loader>
          </div>
        </ReactModalWithStyle>
        <ReactModalWithStyle
          isOpen={this.state.modal}
          onRequestClose={this.toggleModal}
          modalHeader={
            <span>
              <b>Загрузите положительное заключение экспертной коллегии</b>
            </span>
          }
          modalFooter={
            <>
              <Button bsStyle="primary" type="submit" onClick={this.onCreate}>
                Создать заявку
              </Button>
              <Button bsStyle="danger" onClick={this.toggleModal}>
                Отменить
              </Button>
              {this.props.createFormError ? (
                <Alert bsStyle="danger" style={{ textAlign: 'left' }}>
                  <strong>{this.props.createFormError}</strong>
                </Alert>
              ) : null}
            </>
          }
        >
          <form className="form-horizontal">
            <div className="form-group">
              <div className="col-xs-12 fullwidth">
                <label className="control-label">
                  <div className="reportbox-content-desc">
                    <span>
                      Положительное экспертное заключение (.pdf, .doc, .docx)
                    </span>
                  </div>
                </label>
              </div>
              <div className="col-xs-12">
                <input
                  type="file"
                  onChange={(e) => {
                    this.setState({
                      protocol: e.target.files[0],
                    });
                  }}
                />
              </div>
              <div className="col-xs-12 fullwidth">
                <div className="alert alert-warning" role="alert">
                  Необходимо загрузить оригинал протокола экспертной коллегии,
                  полученной в результате экспертизы проекта или
                  программы Fast Track.
                </div>
              </div>
            </div>
          </form>
        </ReactModalWithStyle>
      </LoadingDots>
    );
  }
}

RequestCreate.propTypes = {
  loaders: PropTypes.shape({}).isRequired,
  forms: PropTypes.array.isRequired,
};

const mapDispatchToProps = {
  createForm,
  onUploadProtocol,
  onChangeProtocol,
  errorCreateFormAction: errorCreateForm,
};

const mapStateToProps = (state) => ({
  loaders: state.forms.loaders,
  forms: state.forms.forms,
  modeLoaded: state.forms.modeLoaded,
  createFormError: state.forms.createFormError,
  errorCreateForm: state.forms.errorCreateForm,
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestCreate);
